import { useEffect } from 'react';
import { useSmenaStore, useSmenaGamesStore } from '../../stores';
import { useApiQuery } from '../../api/hooks';

/**
 * Компонент загрузки данных об играх смены.
 * Автоматически загружает данные когда выбрана смена и синхронизирует с глобальным store.
 * Должен быть размещён в FullLayout для работы на всех страницах.
 */
export default function SmenaGamesLoader() {
    const smenaId = useSmenaStore(state => state.smenaId);
    const setGames = useSmenaGamesStore(state => state.setGames);
    const reset = useSmenaGamesStore(state => state.reset);

    const { data: games } = useApiQuery(
        ['smena', smenaId, 'games'],
        `/api/camps/admin/smena/${smenaId}/games`,
        { enabled: !!smenaId && smenaId !== 'undefined' }
    );

    useEffect(() => {
        if (!smenaId || smenaId === 'undefined') {
            reset();
            return;
        }
        if (games) {
            setGames(games);
        }
    }, [smenaId, games, setGames, reset]);

    return null;
}
